import Home from './Components/LandingPage/Home';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import About from './Components/About/About';
import Skills from './Components/SkillsArea/SkillArea';
import Projects from './Components/ProjectsArea/ProjectsArea';
import Query from './Components/QueryArea/Query';
import TopLink from './Components/TakeTop/TakeTop'


function App() {
  return (
    <>
      <Header />
      <Home />
      <About />
      <Skills />
      <Projects />
      <Query />
      <TopLink />
      <Footer />
    </>
  );
}

export default App;
